module.exports = __webpack_public_path__ + "img/Upsell_Image@3x.de579fec.png";